import VStack from "shared/components/layout/stack/VStack";
import ProjectsDashboardOverviewData from "features/projects/project-dashboard/single/ProjectsDashboardOverviewData";
import ProjectsDashboardOverviewBudget from "features/projects/project-dashboard/single/ProjectsDashboardOverviewBudget";
import ProjectsDashboardOverviewProject from "features/projects/project-dashboard/single/ProjectsDashboardOverviewProject";
import Loading from "shared/components/feedback/loading/Loading";

import { useProjectsDashboardRelatedData } from "features/projects/project-dashboard/single/useProjectsDashboardData";

const ProjectsDashboardOverview = () => {
    const { useRelatedProjectsDashboard } = useProjectsDashboardRelatedData();
    const summaryMoney = useRelatedProjectsDashboard("money");
    const summaryHours = useRelatedProjectsDashboard("hours");

    if (summaryMoney.isLoading || summaryHours.isLoading) {
        return <Loading />;
    }

    return (
        <VStack style={{ gap: "40px" }}>
            <ProjectsDashboardOverviewData />
            <div>
                <ProjectsDashboardOverviewBudget />
            </div>
            {(summaryMoney?.data?.length > 0 ||
                summaryHours?.data?.length > 0) && (
                <div>
                    <ProjectsDashboardOverviewProject />
                </div>
            )}
        </VStack>
    );
};

export default ProjectsDashboardOverview;
